import React from "react";

const SvgImageView = props => <svg viewBox="0 0 16 16" {...props}><path fillRule="evenodd" d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm6 5c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm-3 6v-1.906L5 10l2 1 5-3 1 3v2H3z" clipRule="evenodd" /></svg>;

export default SvgImageView;